import React, { useState, useEffect } from 'react';
import Combobox from './Combobox';

const BASE_API_URL = "https://country-state-city-search-rest-api.p.rapidapi.com/";

const divStyle = {
    display: "inline-block",
    width: "100px"
};
const comboStyle = {
    width: '250px'
};

const clientSecret = {
    UserName: "adesai21",
    RegdEmail: 'myapp@notmail.net',
    SecretKey: 'abracadabra'
};

//Ref: https://www.universal-tutorial.com/rest-apis/free-rest-api-for-country-state-city
export function CountriesStatesCities() {
    var [countries, setCountries] = useState([]);
    var [selectedCountry, setSelectedCountry] = useState();
    var [states, setStates] = useState([]);
    var [selectedState, setSelectedState] = useState();
    var [cities, setCities] = useState([]);
    var [selectedCity, setSelectedCity] = useState();

    //ToDo: Implement API to show planetory positions
    //RefUrl: https://github.com/csymlstd/visible-planets-api

    useEffect(() => {
        //Populate the countries combobox by default
        fetchCountries();
    }, []);

    function createApiHeaders() {
        return {
            'x-rapidapi-key': '3bffb589bamshe663ba8eeaec494p1067edjsnf23d4fdc1c55',
            'x-rapidapi-host': 'country-state-city-search-rest-api.p.rapidapi.com'
        };
    }

    async function fetchCountries() {
        console.log('fetching countries');
        let newCountries = [];
        const callUrl = BASE_API_URL + 'allcountries';
        const options = {
            method: 'GET',
            headers: createApiHeaders()
        };

        try {
            const response = await fetch(callUrl, options);
            const data = await response.json();
            if (data) {
                console.log(data[0]);
                let pagedCountries = data.map(country => {
                    return {
                        value: country.isoCode, text: country.name,
                        currency: country.currency,
                        flag: country.flag,
                        latitude: country.latitude,
                        longitude: country.longitude,
                        gmtOffset: country.timezones[0].gmtOffset
                    }
                });
                newCountries = newCountries.concat(pagedCountries);
                newCountries.sort(objectSorter);
                newCountries = [{
                    value: '', text: '',
                    currency: '', flag: '', latitude: '', longitude: '', gmtOffset: ''
                }, ...newCountries];
                //console.log(newCountries);
                setCountries(newCountries);
            }
        } catch (error) {
            console.error(error);
        }
    }

    function objectSorter(prev, next) {
        return (prev.text < next.text ? -1 : (prev.text === next.text ? 0 : 1));
    }

    async function fetchStates(countryCode) {
        console.log('fetching states for ' + countryCode)
        const callUrl = BASE_API_URL + 'states-by-countrycode?countrycode=' + countryCode;
        const options = {
            method: 'GET',
            headers: createApiHeaders()
        };

        try {
            const response = await fetch(callUrl, options);
            const data = await response.json();
            var newStates = [
                { value: '', text: '' },
                ...data.map(state => { return { value: state.isoCode, text: state.name } }).sort(objectSorter)
            ];
            //console.log(newStates);
            setStates(newStates);

        } catch (error) {
            console.error(error);
        }
    }

    async function fetchCities(stateCode) {
        console.log('fetching cities for ' + stateCode, selectedCountry.value);
        const callUrl = `${BASE_API_URL}cities-by-countrycode-and-statecode?countrycode=${selectedCountry.value}&statecode=${stateCode}`;
        const options = {
            method: 'GET',
            headers: createApiHeaders()
        };

        try {
            const response = await fetch(callUrl, options);
            const data = await response.json();
            //console.log(data);
            setCities([
                { value: '', text: '' },
                ...data.map((city, index) => { return { value: index, text: city.name } }).sort(objectSorter)
            ]);
        } catch (error) {
            console.error(error);
        }
    }

    async function onCountrySelect(e) {
        let foundCountry = countries.find(c => c.value === e.target.value);
        setSelectedCountry(foundCountry);
        console.log(`You selected country - ${foundCountry ? foundCountry.text : 'none'}`);
        setSelectedCity('');
        setCities([]);
        setSelectedState('');
        await fetchStates(e.target.value);
        //fetchStates('GH');
    }

    async function onStateSelect(e) {
        let foundState = states.find(s => s.value === e.target.value);
        setSelectedState(foundState);
        console.log(`You selected state - ${foundState ? foundState.text : 'none'}`);
        setSelectedCity('');
        await fetchCities(e.target.value);
        //fetchCities('BA');
    }

    function onCitySelect(e) {
        let foundCity = cities.find(c => c.value == e.target.value);
        setSelectedCity(foundCity);
        console.log(`You selected city - ${foundCity ? foundCity.text : 'none'}`);
    }

    function showContryDetails() {
        if (selectedCountry)
            return `${selectedCountry.text} - ${selectedCountry.currency} - ${selectedCountry.flag} - ${selectedCountry.latitude} - ${selectedCountry.longitude} - ${selectedCountry.gmtOffset}`;
        else
            return '';
    }

    return (
        <>
            <h1>Countries, States, Cities</h1>
            <br/>
            <div>
                <label style={divStyle}>Country:</label> <Combobox title="Countries" estyle={comboStyle} selectedOption={selectedCountry}
                    availableOptions={countries} onOptionSelect={onCountrySelect} />
            </div>
            <br/>
            <div>
                <label style={divStyle}>State:</label> <Combobox title="States" estyle={comboStyle} selectedOption={selectedState}
                    availableOptions={states} onOptionSelect={onStateSelect} />
            </div>
            <br />
            <div>
                <label style={divStyle}>City:</label> <Combobox title="Cities" estyle={comboStyle} selectedOption={selectedCity}
                    availableOptions={cities} onOptionSelect={onCitySelect} />
            </div>
            <div className="mt-5 mb-5"></div>
            <h5>Your selection:</h5>
            <ul class="list-group">
                <li class="list-group-item"><span style={divStyle}>Country</span>: {showContryDetails()}</li>
                <li class="list-group-item"><span style={divStyle}>State</span>: {selectedState ? selectedState.text : ''}</li>
                <li class="list-group-item"><span style={divStyle}>City</span>: {selectedCity ? selectedCity.text : ''}</li>
            </ul>
        </>
    );
}